import {SAVE_TOKEN, REMOVE_USER, LOGIN_USER, LOAD_USERS, LOGIN_USER_ERROR } from "./UserType";

const initialState = {
    isLoading: false,
    isLoggedIn: false,
    buyer: null,
    uid:null,
    error: '',
    navigate: false,
    token:null,
    isAdmin:false
}


const userSlice = (state=initialState, action)=>{
    switch(action.type){
        case LOAD_USERS: return {
            ...state,
            isLoading: true,
        };

        case SAVE_TOKEN: 
        console.log(action.payload)
        return {
            
            ...state,
            isLoading: false,
            isLoggedIn: true,
            token: action.payload.token,
            uid: action.payload.uid,
            navigate: true,
            error: ""
        }

        case LOGIN_USER: 
        console.log(action.payload)
        return {
            
            ...state,
            isLoading: false,
            buyer: action.payload,
            navigate: true,
            error: ""
        }
        case REMOVE_USER:
        return {
            ...state,
            buyer: null,
            isLoggedIn:false,
            isAdmin:false,
            token:null,
            uid: null
        }
        case LOGIN_USER_ERROR: return {
            ...state,
            isLoading: false,
            error: action.payload,
            navigate: false,
            buyer: null
        }
        default: return state
    }
}

export default userSlice